define((require) => {
    "use strict";

    var ImprovedModel  = require("shared/zbone/ImprovedModel"),
        Syncer         = require("shared/services/sync/Syncer");

    /**
     * The group meta data.
     *
     * @class GroupMetadata
     * @constructor
     * @author Antonio Lagrotteria
     */
    return ImprovedModel.extend("Group Metadata", {

        defaults: {
            type:        null
        },

        relations: [],

        constructor: function() {
            this.__super();
            Syncer.State.state(this).immutable = true;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/GroupMetadata.js